<template>
    <el-form-item class="radio-container" :label="label">
        <el-radio-group class="radio-group" v-model="selectValue" :disabled="disable"  v-for="value in radios" :key="value" @change="radioChange">
            <el-radio-button class="radio-button" :label="value" border>{{value}}</el-radio-button>
        </el-radio-group>
    </el-form-item>
</template>

<script>
export default {
    props:{
        radios:{
            default: function() {
                return [];
            },
            type: Array,
            required: true
        },
        label:'',
        must:{
            type: Number,
            default: 0
        },
        colon:{
            type: Number,
            default: 0
        },
        disable:false,
        value:''
    },
    data () {
        return {
            selectValue:''
        }
    },
    mounted(){
        this.selectValue = this.value
    },
    methods:{
        radioChange(){
            this.$emit("input",this.selectValue)
        }
    }
}
</script>

<style scoped>

.radio-container{
    width: auto;
    height: 36px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.radio-container>span{
    font-size: 18px;
    color: #333333;
}
.radio-container>span>b{
    width: 100px;
    font-size: 18px;
    color: #FF2B2B;
    text-align: right;
}
.radio-group{
    position: relative;
    right: 125px;
}
.radio-button{
    margin: 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/wjt-radio.vue